import 'flatpickr/dist/flatpickr.css'
import Vue from 'vue'
import VueFlatPicker from 'vue-flatpickr-component'

Vue.use(VueFlatPicker)
